import React, { useState } from "react";
import toast from "react-hot-toast";
import HomeService from "../Services/HomeService";
import { useNavigate } from "react-router-dom";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "rgb(131, 144, 155)",
  margin: "0px 0px 10px 0px",
  fontWeight: "bold",
};

function AddFooterMenu() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    sectionName: "",
    heading: "",
    subHeadings: [""], // Initialize with one empty subheading
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubHeadingChange = (index, value) => {
    const newSubHeadings = [...formData.subHeadings];
    newSubHeadings[index] = value;
    setFormData({ ...formData, subHeadings: newSubHeadings });
  };

  const addSubHeading = () => {
    setFormData({
      ...formData,
      subHeadings: [...formData.subHeadings, ""],
    });
  };

  const removeSubHeading = (index) => {
    if (formData.subHeadings.length <= 1) {
      toast.error("At least one subheading is required");
      return;
    }

    const newSubHeadings = formData.subHeadings.filter((_, i) => i !== index);
    setFormData({ ...formData, subHeadings: newSubHeadings });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!formData.sectionName.trim()) {
      toast.error("Please enter section name");
      return;
    }

    if (!formData.heading.trim()) {
      toast.error("Please enter heading");
      return;
    }

    // Filter out empty subheadings
    const validSubHeadings = formData.subHeadings
      .map((sub) => sub.trim())
      .filter((sub) => sub !== "");

    if (validSubHeadings.length === 0) {
      toast.error("Please enter at least one subheading");
      return;
    }

    setLoading(true);

    // Prepare data according to Postman body structure
    const footerMenuData = {
      sectionName: formData.sectionName.trim(),
      heading: formData.heading.trim(),
      subHeadings: validSubHeadings,
    };

    console.log("Footer Menu Data:", footerMenuData);

    try {
      const res = await HomeService.createFooterMenu(footerMenuData);
      if (res?.status) {
        toast.success("Footer menu section added successfully!");
        clearForm();
        navigate("/manage-footer-menu"); // Adjust this route as needed
      } else {
        toast.error(res?.message || "Failed to add footer menu section.");
      }
    } catch (error) {
      toast.error("Failed to add footer menu section.");
      console.error("Error adding footer menu:", error);
    } finally {
      setLoading(false);
    }
  };

  const clearForm = () => {
    setFormData({
      sectionName: "",
      heading: "",
      subHeadings: [""],
    });
  };

  return (
    <div className="main_wrap" style={{ marginTop: "6rem" }}>
      <div className="container-fluid">
        <div className="mt-5">
          <div style={headLineStyle} className="page-headline">
            Add Footer Menu Section
          </div>
          <hr />

          <section className="chartBox_area">
            <form onSubmit={handleSubmit}>
              <div className="row">
                {/* Section Name Input */}
                <div className="col-md-6 mt-3">
                  <label htmlFor="sectionName">
                    Section Name<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="sectionName"
                    className="form-control"
                    name="sectionName"
                    value={formData.sectionName}
                    onChange={handleChange}
                    placeholder="e.g., Quick Links, Company, Support"
                    required
                  />
                  <div className="form-text">
                    Internal reference name for this section
                  </div>
                </div>

                {/* Heading Input */}
                <div className="col-md-6 mt-3">
                  <label htmlFor="heading">
                    Heading<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="heading"
                    className="form-control"
                    name="heading"
                    value={formData.heading}
                    onChange={handleChange}
                    placeholder="e.g., Explore, Support, Company"
                    required
                  />
                  <div className="form-text">
                    The main title displayed in the footer
                  </div>
                </div>

                {/* Sub Headings Section */}
                <div className="col-md-12 mt-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <label className="mb-0">
                      Sub Headings<span className="text-danger">*</span>
                    </label>
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      onClick={addSubHeading}
                      style={{
                        borderRadius: "8px",
                        padding: "5px 15px",
                        fontSize: "14px",
                      }}
                    >
                      <i className="fas fa-plus me-1"></i> Add More
                    </button>
                  </div>

                  {formData.subHeadings.map((subHeading, index) => (
                    <div key={index} className="input-group mb-3">
                      <input
                        type="text"
                        className="form-control"
                        value={subHeading}
                        onChange={(e) =>
                          handleSubHeadingChange(index, e.target.value)
                        }
                        placeholder={`Subheading ${
                          index + 1
                        } (e.g., About Us, Contact)`}
                        required={index === 0}
                      />
                      {formData.subHeadings.length > 1 && (
                        <button
                          type="button"
                          className="btn btn-outline-danger"
                          onClick={() => removeSubHeading(index)}
                          style={{
                            borderTopLeftRadius: "0",
                            borderBottomLeftRadius: "0",
                          }}
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      )}
                    </div>
                  ))}

                  <div className="form-text">
                    Enter individual menu items/links for this footer section
                  </div>
                </div>
              </div>

              {/* Submit Buttons */}
              <div className="row mt-4">
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn mt-3"
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                      padding: "10px 30px",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <i className="fa-solid fa-spinner fa-spin me-2"></i>
                        Adding Footer Section...
                      </>
                    ) : (
                      "Add Footer Section"
                    )}
                  </button>
                  {/* <button
                    type="button"
                    className="btn btn-secondary mt-3 ml-2"
                    style={{
                      borderRadius: "13px",
                      padding: "10px 30px",
                      marginLeft: "10px",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                    onClick={clearForm}
                  >
                    Clear Form
                  </button> */}
                </div>
              </div>
            </form>
          </section>
        </div>
      </div>
    </div>
  );
}

export default AddFooterMenu;
